import { useNavigate } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import { ChevronRightIcon } from 'Asset/icon';
import { TextRegular, TextSemiBold } from 'UiKit/typography';

import styles from './styles.module.css';

const ColumnContent = ({ values, t }) => {
  const navigate = useNavigate();
  const handleClickViewContent = () => {
    navigate(`/report/host-task?search=${values?.hostName}`);
  };

  return (
    <Box className={styles['column__container']}>
      <TextRegular className={styles['column__text--total-content']}>{values?.totalTasks}</TextRegular>
      <Box className={styles['column__button--view-content']} onClick={handleClickViewContent}>
        <TextSemiBold className={styles['column__text--view-content']}>{t("tableColumnHost.seeContent")}</TextSemiBold>
        <ChevronRightIcon size={'12px'} color="var(--color-primary50)" />
      </Box>
    </Box>
  );
};

export default ColumnContent;
